import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster';

// Helper to transform legacy form values to DynamicContent format
const transformToDynamic = (values, fieldName) => {
    return {
        es: values[fieldName] || '',
        en: values[`${fieldName}_en`] || '',
        fr: values[`${fieldName}_fr`] || '',
        it: values[`${fieldName}_it`] || '',
        pt: values[`${fieldName}_pt`] || '',
    };
};

async function submit(values, dispatch) {
    const query = `
        mutation updateCancellationPolicyDynamic(
            $policyType: String!,
            $allowOwner: PolicyFieldInput,
            $sharedCheckInTitle: PolicyFieldInput,
            $sharedCheckOutTitle: PolicyFieldInput,
            $description: PolicyFieldInput,
            $desc1: PolicyFieldInput,
            $desc2: PolicyFieldInput,
            $desc3: PolicyFieldInput,
            $tripStart: PolicyFieldInput,
            $desc4: PolicyFieldInput,
            $desc5: PolicyFieldInput,
            $desc6: PolicyFieldInput,
            $review: PolicyFieldInput,
            $desc7: PolicyFieldInput
        ) {
            updateCancellationPolicyDynamic(
                policyType: $policyType,
                allowOwner: $allowOwner,
                sharedCheckInTitle: $sharedCheckInTitle,
                sharedCheckOutTitle: $sharedCheckOutTitle,
                description: $description,
                desc1: $desc1,
                desc2: $desc2,
                desc3: $desc3,
                tripStart: $tripStart,
                desc4: $desc4,
                desc5: $desc5,
                desc6: $desc6,
                review: $review,
                desc7: $desc7
            ) {
                status
                message
            }
        }
    `;

    // Transform form values to DynamicContent format
    const variables = {
        policyType: 'Shared',
        allowOwner: transformToDynamic(values, 'allowOwner'),
        sharedCheckInTitle: transformToDynamic(values, 'cancellationCheckIn'),
        sharedCheckOutTitle: transformToDynamic(values, 'cancellationCheckOut'),
        description: transformToDynamic(values, 'cancellationDescription'),
        desc1: transformToDynamic(values, 'cancellationDesc1'),
        desc2: transformToDynamic(values, 'cancellationDesc2'),
        desc3: transformToDynamic(values, 'cancellationDesc3'),
        tripStart: transformToDynamic(values, 'cancellationTripStart'),
        desc4: transformToDynamic(values, 'cancellationDesc4'),
        desc5: transformToDynamic(values, 'cancellationDesc5'),
        desc6: transformToDynamic(values, 'cancellationDesc6'),
        review: transformToDynamic(values, 'cancellationReview'),
        desc7: transformToDynamic(values, 'cancellationDesc7'),
    };

    const resp = await fetch('/graphql', {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        }),
        credentials: 'include',
    });

    const { data } = await resp.json();

    if (data.updateCancellationPolicyDynamic.status === "success") {
        showToaster({ messageId: 'updateSuccess', toasterType: 'success' });
    } else {
        showToaster({ messageId: 'updateFailed', toasterType: 'error' });
    }
}

export default submit;
